<template>
  <div class="micro-stats">
    <div v-for="row in stats" :key="row.label" class="row">
      <div class="row-inner">
        <div class="row-title">{{ row.label }}</div>
        <MicroChartCell :data="row" />
        <div class="row-stats">
          <div
            v-for="stat in row.stats"
            :key="stat.id"
            class="stat"
            :class="{ disabled: stat.disabled, second: stat.id === 'missing' }"
          >
            <div class="label">
              <div v-if="stat.icon" class="icon" :class="stat.icon" />
              {{ $t(stat.label) }}
            </div>
            <div class="abs">{{ stat.value }}</div>
            <div class="perc">{{ stat.percent && (stat.percent * 100).toFixed(0) + '%' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MicroChartCell from './MicroChartCell.vue'
import { format as d3_format } from 'd3-format'
import { normalizeCsvHeader } from '@/utils/microdataUtils.js'

export default {
  components: { MicroChartCell },
  props: ['data', 'total', 'sortedOptions'],
  computed: {
    stats() {
      let ordOp = this.sortedOptions.map(x => x.label)
      let colStats = this.data.map(d => {
        if (d.type === 'key') return { ...d, label: normalizeCsvHeader(d.label), stats: [] }
        let stats = []
        stats[0] = {
          id: 'valid',
          icon: 'tick',
          label: 'valid',
          value: d.count,
          percent: d.count / this.total,
        }
        stats[1] = {
          id: 'missing',
          icon: 'cross',
          disabled: this.total === d.count,
          label: 'missing',
          value: this.total - d.count,
          percent: (this.total - d.count) / this.total,
        }
        if (d.type === 'text') {
          stats[2] = { id: 'unique', label: 'unique_values', value: d.unique }
          stats[3] = {
            id: 'most_common',
            label: 'most_common',
            value: d.values ? d.values[0].label : '-',
            percent: d.values ? (d.values[0].count / d.count) : 1,
          }
        } else if (d.type === 'num') {
          stats[2] = { id: 'average', label: 'average', value: this.valueFormat(d.average) }
          stats[3] = {
            id: 'deviation',
            label: 'deviation',
            value: this.valueFormat(+d.deviation || 0),
          }
        }
        return { ...d, label: normalizeCsvHeader(d.label), stats }
      })
      let finalStats = ordOp.map(x => {
        return colStats.find(el => normalizeCsvHeader(el.label) === normalizeCsvHeader(x))
      })
      return finalStats
    },
  },
  mounted() {},
  methods: {
    valueFormat(v) {
      return d3_format('.2s')(v)
    },
  },
}
</script>

<style lang="stylus" scoped>
.micro-stats
  overflow-y: auto
  max-height: 80vh

  .row
    padding-top: vw(50px)
    padding-bottom: vw(50px)
    // padding-left: vw(175px)
    border-bottom: solid 1px #ddd

    .mobile &
      padding: vw(30px) vw(20px)

  .row-inner
    display: flex
    overflow: hidden
    margin-right: auto
    margin-left: auto
    max-width: vw(1024px)

    .mobile &
      flex-wrap: wrap
      max-width: 100%
      width: 100%

  .row-title
    m-font-size(20, 28)
    flex: 0 0 25%
    overflow: hidden
    color: #000
    font-weight: 600

    .mobile &
      flex: 0 0 100%
      margin-bottom: vw(20px)

  .micro-chart-cell
    flex: 0 0 45%
    padding-right: vw(40px)
    padding-left: vw(40px)

    .mobile &
      flex: 0 0 100%
      padding: 0

    >>> .micro-list
      justify-content: flex-start

    >>> .micro-histogram
      font-size: 11px

  .row-stats
    flex: 0 0 30%
    overflow: hidden

    .mobile &
      flex: 0 0 100%
      margin-top: vw(20px)

    .stat
      display: flex
      margin-bottom: vw(10px)

      &.disabled
        opacity: 0.5

      &.alpha
        opacity: 0.7

      .label
        display: flex
        flex: 1 1 0%
        font-weight: bold

        .icon
          margin-right: vw(5px)

          &.tick
            m-icon("tick", 20)

          &.cross
            m-icon("close", 20)

      .abs
        flex: 0 0 vw(100px)
        margin-left: vw(20px)
        // text-align: right

      .perc
        flex: 0 0 vw(50px)
        margin-left: vw(10px)
        text-align: right

    .second
      margin-bottom: vw(40px)
</style>
